import React from "react";

import { useAuthProvider } from "hooks";

export type AuthContextValue = ReturnType<typeof useAuthProvider>;

export const AuthContext = React.createContext<AuthContextValue>({
  user: null,
  tokens: null,
  isLoading: true,
  login: async () => {},
  register: async () => {},
  logout: async () => {},
  refetch: (() => {}) as AuthContextValue["refetch"],
});

export const AuthProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const value = useAuthProvider();

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
